import { render, staticRenderFns } from "./PassFormBlock.vue?vue&type=template&id=801c5a40"
import script from "./PassFormBlock.vue?vue&type=script&lang=js"
export * from "./PassFormBlock.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports